import CallButtonView from './callButton.view';

export default CallButtonView;
